// extracted by mini-css-extract-plugin
export var parcelRow = "_sy-0";